import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

const propertyFilters = ['client_id', 'name', 'email', 'status', 'department'];

export default class CreateCronFilterForm {
  public property: string = '';
  public value: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    property: [
      (v: string) => !!v || 'Property is required',
      (v: string) => v.length >= 3 || 'Property has to be at least 3 characters',
      (v: string) => propertyFilters.indexOf(v) !== -1 || 'Invalid Property',
    ],
    value: [
      (v: string) => !!v || 'Value is required',
    ],
  };
}
